import type { FaireProductEntity } from "../../entity_types/product";

export const p_zgcgzag58p: FaireProductEntity = {
  token: "p_zgcgzag58p",
  type: "product",
  name: "Sour Wild Strawberry Fish - Swedish Candy 5.2oz (150g)",
  brandToken: "b_b19cqe097d",
  brandName: "BonBon - A Swedish Candy Co",
  imageUrl: "https://cdn.faire.com/fastly/2daabc03e20456f5200e81fd62f8163173dc69dd9cc722a4982f5d21de86c3fb.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3c1af255b7616ea5ee62eef3ee6e5c1f91a3f4582ef3a85658e95381a4a97b98.png",
    "https://cdn.faire.com/fastly/81869aebad5d21692a2ea9bde6552261e62a81c133272131ffe0c2b4e5271ed1.png"
  ],
  priceDollars: 4,
  description: "We spent 18 months of research and development to create, what is to our minds, the best gummy every produced. \n\nThe Sour wild strawberry fish is a vegan, gluten-free, naturally colored and flavored sour candy made by a small factory in the south of Sweden. \n\nCoated in sour sugar, wild strawberry is the dominant aroma and it is complemented by a dash of sour raspberry for that extra kick!\n\nThis vegan and gluten-free candy is a fresh take on the classic Swedish Fish, perfect inside a Easter gifting basket. The perfect Valentine's day gift. ",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:23.119Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
